'use strict'

function stripCssComments (cssText) {

  return String(cssText || '').replace(/\/\*[\s\S]*?\*\//g, '')
}

function scopeCss (prefix, cssText) {

  const source = stripCssComments(cssText)

  if (!source.trim()) return ''

  return source.replace(/([^{}]+)\{/g, (match, selectors) => {

    if (selectors.trim().startsWith('@')) return match

    const prefixed = selectors
      .split(',')
      .map((selector) => selector.trim())
      .filter(Boolean)
      .map((selector) => `${prefix} ${selector}`)
      .join(', ')

    return `${prefixed} {`
  })
}

module.exports = {
  stripCssComments,
  scopeCss
}
